import type { AppModule } from '@dott/core';

import * as routes from './routes.js';

export const RequestsModule: AppModule = {
  routes,
};
